import { Period, TransactionsType } from '../hoc/dashboard/types';

const getQuery = ({
  period,
  date,
  transactionsType,
}: {
  period?: Period;
  date: string[];
  transactionsType?: TransactionsType;
}) => {
  let typeId;

  switch (transactionsType) {
    case TransactionsType.INCOMING:
      typeId = 'ed7a1d26-c31f-47fa-a38c-6db80aabfb41';
      break;
    case TransactionsType.OUTGOING:
      typeId = '07f5c1a7-65ff-4ee4-bdbf-936dbd803869';
      break;
    default:
      typeId = transactionsType;
      break;
  }

  let query = '?';

  if (period) {
    query += `period=${period.toLowerCase()}`;
  }
  if (date && date[0]) {
    query += `&transferDateFrom=${date[0]}`;
  }
  if (date && date[1]) {
    query += `&transferDateTo=${date[1]}`;
  }
  if (typeId) {
    query += `&typeId=${typeId}`;
  }

  return query;
};

export default getQuery;
